// About.jsx
import React from 'react';
import './About.css'; // 필요하면 별도 스타일

export default function About() {
  return (
    <div className="about-page-container">
      <h1>ABOUT</h1>
      <p>History & Awards</p>

      <div className="timeline">
       <div className="year">2021</div>
        <p>10) Korea Water Resources Corporation Public Big Data Contest : 2nd</p>
        <p>12) Gangwon Province Fire Safety AI Prediction Competition : 3th</p>

       <div className="year">2022</div>
        <p>03) Stop-Covid-19 SW Challenge : 3th</p>
        <p>12) Upcoming life in Space SW Challenge</p>
        <p>12) Global AI 2022 : 3th</p>

        <div className="year">2023</div>
        <p>06) South Korea's Digital Talent Training Project : 2nd</p>
        <p>07) Daegu City Public Data Utilization Competition : Grand Prize</p>
        <p>08) SKT_Tech4Good Hackathon : Idea Prize </p>
        <p>09) ICT Innovation square AI Hackathon : 4th</p>
        <p>12) 2nd Digital Talent Training Project in Korea : Grand Prize</p>
        
        <div className="year">2024</div>
        <p>02) THU's AICOSS Industrial Challenge : Grand Prize</p>
        <p>07) WFK ICT Volunteer : Indenessia Jember</p>
        <p>12) 2024 Kyungpook National University Startup Competition : Best Prize</p>

        <div className="year">2025</div>
        <p>02) KNU Technology Startup Boot Camp: Best Award</p>
        <p>05) KB Bank AI Competetion's Web Developerof the Committee </p>
        <p>07) ICFSS International Conference's Web Developer of the Committee </p>
        <p>08) Communitiy Well CTO </p>
        <p>08) ICT Innovation Square Startup Competetion: 2nd  </p>
        <p>08) Daegu Tourism Startup Idea Contest 1st</p>
        <p>10) Daegu Buk-gu Start-up Idea Audition</p>
        <p>11) ICT Innovation Championship game : Grand Prize</p>
      </div>
    </div>
  );
}
